<template>
  <el-card class="box-card mb-50 box-search">
    <span class="tilte-search mb-10">{{ $t('companies.index.company_search') }}</span>
    <el-form ref="formSearch" :model="dataSearch" @submit.prevent="search">
      <el-form-item prop="name">
        <el-input :placeholder="$t('companies.company_name')" v-model="dataSearch.name"/>
      </el-form-item>
      <div class="mt-25 mb-25">
        <el-button type="danger" class="btn-search" @click="search" @keyup.enter.native="search">{{ $t('btn_search') }}</el-button>
        <el-button type="info" class="btn-clear" @click="resetForm">{{ $t('btn_clear') }}</el-button>
      </div>
    </el-form>
    <table-data
      :data="data" :loading="loading" :columns="columns"
      :buttons="buttons" :hasCreate="true"
      @change-page="handleChangePage" @click-button="handleClickButtonTable"
      @handle-redirect-create="redirectCreate"
      @sort="sort">
    </table-data>
  </el-card>
</template>
<script>
  import {getListData} from '../../api/company'
  export default {
    props: {
      urls: { type: Object, required: true, default: {} },
    },

    data() {
      return {
        formSearch: {
          name: "",
        },
        data: {},
        loading: true,
        columns: [
          { prop: "name", label: "企業名", sortable: "custom", class: "" },
          { prop: "industries_name", label: "業種", sortable: false, width: "170" },
          { prop: "quantity_shop", label: "登録数", sortable: "custom", class: "text-center", width: "120" },
          { prop: "last_login_datetime", label: "最終ログイン日", sortable: "custom",  class: "", width: "145"  }
        ],
        buttons: [
          { id: "1", label: "選択", type: "select", class: "btn btn-select" },
          { id: "2", label: "詳細", type: "detail", class: "btn btn-detail" }
        ],
        sortProp: {key: 'created_at', dir: 'descending'},
        dataSearch: {
          name: ""
        }
      }
    },

    methods: {
      getListData(page=1) {
        getListData(page, this.formSearch.name, this.sortProp)
        .then(response => response.json())
        .then(response => {
          this.data = response.data;
          this.loading = false;
        })
        .catch((error) => {
        })
        .finally(() => {
        });
      },

      handleChangePage(page) {
        this.loading = true;
        this.getListData(page);
      },

      search() {
        let data = this.dataSearch;
        this.formSearch = Object.fromEntries(Object.entries(this.dataSearch).map(([k, v]) => [k, v]));
        this.loading = true;
        this.getListData();
      },

      handleClickButtonTable(type, row) {
        switch(type) {
          case 'select':
            window.location.href = "/shops?company_id="+row.id;
            break;
          case 'detail':
            window.location.href = "/companies/"+row.id;
            break;
        }
      },

      sort(sortProps) {
        this.sortProp = {key: sortProps.prop, dir: sortProps.order};
        this.getListData(1);
      },

      resetForm() {
        this.dataSearch.name = '';
      },

      redirectCreate() {
        window.location.href = this.urls.create;
      }
    },

    created() {
      this.getListData();
    },
  }
</script>
